import React, {useEffect, useRef, useState} from 'react';
import {Tag} from 'antd';
import ProfileContainer from "../components/ProfileContainer";
import ProfileKeyClientRow from "../components/ProfileKeyClientRow";

const MAX_LENGTH = 3;

const renderBadge = (text, type) => {
    const colorMap = {
        industry: 'default',
        skill: 'geekblue',
        discipline: 'purple'
    };
    // const iconMap = {
    //     industry: BankOutlined,
    //     skill: ToolOutlined,
    //     discipline: TeamOutlined
    // };
    //
    // const TagIcon = iconMap[type] || React.Fragment;
    return (
        <Tag
            key={text}
            // icon={<TagIcon />}
            color={colorMap[type]}>
            {text}
        </Tag>
    )
};

const getPDFAssets = (project) => {
    return project?.assets?.filter(asset =>
        asset.content_type === "PDF"
    ) || [];
};

const getMediaAssets = (project) => {
    const assets = project?.assets?.filter(asset =>
        (asset.content_type === "Image" || asset.content_type === "Video") && asset.path
    ) || [];

    assets.unshift({ path: project.image_path, caption: project.headline, id: project.id })
    return assets;
};


const ReadMoreText = ({ text, dangerouslySetInnerHTML, maxLines = 3 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const checkLines = () => {
            const element = textRef.current;
            if (!element) return;

            // Get line height and total height
            const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
            const totalHeight = element.scrollHeight;
            const maxHeight = lineHeight * maxLines;

            // Show button if content exceeds max lines
            setShowButton(totalHeight > maxHeight);
        };

        checkLines();
        // Recheck on window resize
        window.addEventListener('resize', checkLines);
        return () => window.removeEventListener('resize', checkLines);
    }, [text, maxLines]);

    console.log(dangerouslySetInnerHTML, 'dangerouslySetInnerHTML')
    return (
        <div className="relative max-w-2xl">
            {dangerouslySetInnerHTML ? (
                <div
                    dangerouslySetInnerHTML={{ __html: dangerouslySetInnerHTML }}
                    ref={textRef}
                    className={`${!isExpanded ? `line-clamp-${maxLines}` : ''
                        } transition-all duration-200`}
                />

            ) : (

                <div
                    ref={textRef}
                    className={`${!isExpanded ? `line-clamp-${maxLines}` : ''
                        } transition-all duration-200`}
                >
                    {text}
                </div>

            )}
            {showButton && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="mt-2 text-blue-600 hover:text-blue-800 font-medium focus:outline-none"
                >
                    {isExpanded ? 'Read Less' : 'Read More'}
                </button>
            )}
        </div>
    );
};

// export default ReadMoreText;


const TalentProfileWorkHighlights = ({items =[]}) => {
    // const { talent } = useTalent();

    const [isWorkHighlightsOpen, setIsWorkHighlightsOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [currentAssetIndex, setCurrentAssetIndex] = useState(0);

    const keyClients = TB.sortBy(items, 'display_index');

    // const isTextClamped = elm => elm.scrollHeight > elm.clientHeight

    // new ResizeObserver(e => {
    //     console.clear()
    //     console.log(isTextClamped(e[0].target))
    // }).observe(elem);

    return (
        <div id="project-highlights" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">Project Highlights  {!!keyClients.length && `(${keyClients.length})`}</h4>

                    {!keyClients.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Projects Available</p>
                        </div>
                    )}

                    <div className="flex gap-6 flex-wrap divide-y">
                        {keyClients?.slice(0, isWorkHighlightsOpen ? keyClients.length : MAX_LENGTH).map(client => {
                            return (
                                <ProfileKeyClientRow
                                    key={client.id}
                                    project={client}
                                />
                            )
                        })}
                    </div>

                    {keyClients.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsWorkHighlightsOpen(!isWorkHighlightsOpen)}
                            >
                                <p>{keyClients.length - MAX_LENGTH} {isWorkHighlightsOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isWorkHighlightsOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>
    )
}

export default TalentProfileWorkHighlights;